import React from "react";
import styled from "styled-components";
import SliderArrows from "../SliderArrows/index";
import FilterTabs from "../FilterTabs/index";
import PrettyTitle from "../PrettyTitle/PrettyTitle";
import isMobile from "ismobilejs";
import { getSafe } from "../../utils";

const Wrapper = styled.div`
  display: ${(props) =>
    props.nohead
      ? "-webkit-flex"
      : props.condition
      ? "-webkit-flex"
      : props.condition2
      ? "-webkit-flex"
      : props.video
      ? "-webkit-flex"
      : "none"};
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  padding: ${(props) =>
    props.nohead ? "3rem 0rem 0rem 0rem" : "0 49px 40px 0"};

  @media (max-width: 768px) {
    padding: ${(props) =>
      props.nohead ? "1.5rem 0rem 0rem 0rem" : "0 16px 20px 0"};
    flex-direction: column;
    gap: 20px;
  }
  /* padding: ${(props) => (props.exp ? "0rem 27.2rem" : null)}; */
  .title {
    font-family: ${({ theme }) => theme.fonts.ivy};
    font-style: normal;
    font-weight: 300;
    font-size: 1.5rem;
    width: 100%;

    line-height: 100%;
    span {
      opacity: 0.18;
    }
  }
  .hr {
    width: 250%;
    height: 2px;
  }
  .navigation {
    display: -webkit-flex;
    justify-content: flex-end;
    position: relative;
    z-index: 99999999;
    gap: 15px;

    /* width: ${(props) => (props.todo ? "60%" : "50%")}; */
    align-items: center;
    flex-direction: row;
    @media (max-width: 768px) {
      width: 100% !important;
      flex-direction: column;
      gap: 20px;
    }
  }
`;

function SwiperHeader({
  navigationNextRef,
  navigationPrevRef,
  todoPlaces,
  main,
  sub,
  ALL_ARRAY,
  exp,
  video,
  array,
  nohead,
  setStatus,
  status,
  todo,
}) {
  const condition = getSafe(() => todoPlaces.length === 0) && todo;
  const condition2 = getSafe(() => todoPlaces.length !== 0);
  return (
    <Wrapper
      exp={exp}
      todo={todo}
      nohead={nohead}
      video={video}
      condition={condition}
      condition2={condition2}
    >
      {!nohead && !isMobile().phone && (
        <div className="title">
          <PrettyTitle main={main} sub={sub} />
        </div>
      )}
      {nohead && <hr className="hr" />}
      <div className="navigation">
        {todo && !isMobile().phone && (
          <FilterTabs
            setStatus={setStatus}
            status={status}
            array={array}
            ALL_ARRAY={ALL_ARRAY}
          />
        )}
        <SliderArrows
          navigationPrevRef={navigationPrevRef}
          navigationNextRef={navigationNextRef}
          main={main}
          mobile={isMobile().phone}
        />
        {todo && isMobile().phone && (
          <FilterTabs
            setStatus={setStatus}
            status={status}
            array={array}
            ALL_ARRAY={ALL_ARRAY}
          />
        )}
      </div>
    </Wrapper>
  );
}

export default SwiperHeader;
